import React from 'react';
import PropTypes from 'prop-types';
import Parser from "html-react-parser";

const EacText = ({title, subtitle}) => {

  return (
    <React.Fragment>
      <h3 className="eac-check__title">{Parser(title)}</h3>
      <div className="eac-check__text">{Parser(subtitle)}</div>
    </React.Fragment>
  );

};

EacText.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
};

export default EacText;
